module.exports = __webpack_public_path__ + "static/img/Android-logo.c543fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Android-logo.png
// module id = lePT
// module chunks = 1